import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  BreadcrumbsComponent,
  ButtonModule,
  CardModule,
  CarouselModule,
  DateTimeCardModule,
  IconModule,
  TagModule,
} from '@yoimo/joymo-ui';

import { asyncScheduler } from 'rxjs';
import { AsyncScheduler } from 'rxjs/internal/scheduler/AsyncScheduler';

import {
  DescriptionBlockComponent,
  InfoBlockComponent,
  LiveAndUpcomingComponent,
  SocialShareComponent,
  TagsListComponent,
  VideosListComponent,
  HelpComponent,
} from 'shared-lib';

import { VideoControlComponent } from './video-control/video-control.component';
import { VideoFeedbackComponent } from './video-feedback/video-feedback.component';
import { VideoRoutingModule } from './video-routing.module';
import { VideoStateComponent } from './video-state/video-state.component';
import { VideoComponent } from './video.component';
import { VideoPlayerModule } from '../../video-player/video-player.module';
import { TicketOptionsModule } from '../ticket-options/ticket-options.module';

@NgModule({
  declarations: [VideoComponent, VideoStateComponent],
  imports: [
    CardModule,
    CarouselModule,
    CommonModule,
    IconModule,
    TagModule,
    CarouselModule,
    CardModule,
    TagsListComponent,
    RouterModule,
    VideoPlayerModule,
    VideoRoutingModule,
    ButtonModule,
    TicketOptionsModule,
    VideosListComponent,
    DateTimeCardModule,
    HelpComponent,
    VideoControlComponent,
    LiveAndUpcomingComponent,
    InfoBlockComponent,
    VideoFeedbackComponent,
    BreadcrumbsComponent,
    DescriptionBlockComponent,
    SocialShareComponent,
  ],
  providers: [{ provide: AsyncScheduler, useValue: asyncScheduler }],
})
export class VideoModule {}
